/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA,
  LOAD_DYNAMIC_IMAGES_LIST,
  CREATE_PAYMENT_IN_DETAILS,
  UPDATE_PAYMENT_IN_DETAILS,
  DELETE_PAYMENT_IN_DETAILS,
  LOAD_BEST_SELLING_DETAILS_IMAGES,
  LOAD_DEALS_LIST,
  LOAD_DESTINATION_LIST,
  LOAD_HOLIDAYS_LIST,
  LOAD_TESTIMONIAL_LIST,
  LOAD_PACKAGES_CATEGORY_LIST,
} from "./constants";

import {
  loadDynamicImagesList,
  loadDynamicImagesListSuccess,
  loadDynamicImagesListError,
  createPaymentInListSuccess,
  createPaymentInListError,
  updatePaymentInListSuccess,
  updatePaymentInListError,
  deletePaymentInListSuccess,
  deletePaymentInListError,
  loadDynamicImagesListRecordsMetaDataError,
  loadDynamicImagesListRecordsMetaDataSuccess,
  loadBestSellingDetailsImages,
  loadBestSellingDetailsImagesSuccess,
  loadBestSellingDetailsImagesError,
  loadDealsList,
  loadDealsListSuccess,
  loadDealsListError,
  loadDestinationList,
  loadDestinationListSuccess,
  loadDestinationListError,
  loadHolidaysList,
  loadHolidaysListSuccess,
  loadHolidaysListError,
  loadTestimonialList,
  loadTestimonialListSuccess,
  loadTestimonialListError,
  loadPackageCategoryList,
  loadPackageCategoryListSuccess,
  loadPackageCategoryListError,
} from "./actions";

import {
  loadDynamicImagesDetails,
  createPaymentInDetails,
  updatePaymentInDetails,
  deletePaymentInDetails,
  loadRecordsMetaData,
  loadBestSellingDetailsImagesList,
  loadDealsDetails,
  loadDestinationDetails,
  loadHolidaysDetails,
  loadTestimonialDetails,
  loadPackageCategoryDetails,
} from "./remotes";

function* loadDynamicImagesListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_DYNAMIC_IMAGES_LIST),
    });

    const { explicitLoad } = load;
    yield put(loadDynamicImagesList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDynamicImagesDetails);

        if (result) {
          yield put(loadDynamicImagesListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadDynamicImagesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadDestinationDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_DESTINATION_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadDestinationList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDestinationDetails, destinations);

        if (result) {
          yield put(loadDestinationListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadDestinationListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPackageCategoryDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PACKAGES_CATEGORY_LIST),
    });

    const { explicitLoad } = load;
    const { destinations } = explicitLoad || {};
    yield put(loadPackageCategoryList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPackageCategoryDetails, destinations);

        if (result) {
          yield put(loadPackageCategoryListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPackageCategoryListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadBestSellingDetailsImagesListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_BEST_SELLING_DETAILS_IMAGES),
    });

    const { explicitLoad } = load;
    const { imageList } = explicitLoad || {};
    yield put(loadBestSellingDetailsImages(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadBestSellingDetailsImagesList, imageList);

        if (result) {
          yield put(loadBestSellingDetailsImagesSuccess(result));
        }
      } catch (error) {
        yield put(
          loadBestSellingDetailsImagesError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadDealsDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_DEALS_LIST),
    });

    const { explicitLoad } = load;
    const { dealsList } = explicitLoad || {};
    yield put(loadDealsList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDealsDetails, dealsList);

        if (result) {
          yield put(loadDealsListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadDealsListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadHolidaysDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_HOLIDAYS_LIST),
    });

    const { explicitLoad } = load;
    const { holidayList } = explicitLoad || {};
    yield put(loadHolidaysList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadHolidaysDetails, holidayList);

        if (result) {
          yield put(loadHolidaysListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadHolidaysListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadTestimonialDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_TESTIMONIAL_LIST),
    });

    const { explicitLoad } = load;
    const { testimonialList } = explicitLoad || {};
    yield put(loadTestimonialList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTestimonialDetails, testimonialList);

        if (result) {
          yield put(loadTestimonialListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadTestimonialListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPaymentSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PAYMENT_IN_DETAILS),
    });

    const { paymentDetails } = create || {};

    if (create) {
      try {
        const result = yield call(createPaymentInDetails, paymentDetails);
        if (result) {
          yield put(createPaymentInListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPaymentInListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* updatePaymentSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_PAYMENT_IN_DETAILS),
    });
    const { paymentDetails } = update || {};

    if (update) {
      try {
        const result = yield call(updatePaymentInDetails, paymentDetails);
        if (result) {
          yield put(updatePaymentInListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          updatePaymentInListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* deletePaymentSaga() {
  while (true) {
    const { create } = yield race({
      create: take(DELETE_PAYMENT_IN_DETAILS),
    });
    const { paymentDetails } = create || {};

    if (create) {
      try {
        const result = yield call(deletePaymentInDetails, paymentDetails);
        if (result) {
          yield put(deletePaymentInListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          deletePaymentInListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPaymentDetailsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_DYNAMIC_IMAGES_LIST_RECORDS_META_DATA),
    });

    try {
      const paymentMode = yield call(
        loadRecordsMetaData,
        "getpaymentmode",
        "post"
      );

      let recordsMetaData = {
        paymentModeOptions:
          (paymentMode &&
            paymentMode &&
            paymentMode.length > 0 &&
            paymentMode.map((c) =>
              Object.assign(
                {},
                {
                  label: c.paymentModeName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
      };

      yield put(loadDynamicImagesListRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadDynamicImagesListRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadDynamicImagesListSaga(),
    loadBestSellingDetailsImagesListSaga(),
    deletePaymentSaga(),
    updatePaymentSaga(),
    loadDealsDetailsSaga(),
    loadHolidaysDetailsSaga(),
    loadTestimonialDetailsSaga(),
    createPaymentSaga(),
    loadPaymentDetailsMetaDataSaga(),
    loadDestinationDetailsSaga(),
    loadPackageCategoryDetailsSaga(),
  ]);
}
